function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Link as LinkComponent, useLocation as useLocationHook } from '@amazeelabs/bridge';
import { selectAll } from 'hast-util-select';
import qs from 'query-string';
import React, { createElement, forwardRef } from 'react';
import rehypeParse from 'rehype-parse';
import rehypeReact from 'rehype-react';
import rehypeSlug from 'rehype-slug';
import { omit } from 'remeda';
import { unified } from 'unified';
export { LocationProvider } from '@amazeelabs/bridge';
function isUrl(input) {
    return typeof input === 'string';
}
export function overrideUrlParameters(url, search, hash) {
    if (isUrl(url)) {
        if ([
            '/',
            '#',
            '?',
            'javascript:'
        ].includes(url[0])) {
            return overrideUrlParameters("relative://".concat(url), search, hash).replace('relative://', '');
        }
        var parsed = qs.parseUrl(url, {
            parseFragmentIdentifier: true,
            sort: false
        });
        return qs.stringifyUrl({
            url: parsed.url,
            fragmentIdentifier: typeof hash === 'undefined' ? parsed.fragmentIdentifier : hash,
            query: _object_spread({}, parsed.query, search)
        }, {
            skipNull: true,
            sort: false
        });
    } else {
        return overrideUrlParameters("".concat(url.pathname).concat(url.search ? "?".concat(url.search) : '').concat(url.hash ? "#".concat(url.hash) : ''), search, hash);
    }
}
var isInternalTarget = function(target) {
    return typeof target === 'undefined' || target === '' || target === '_self';
};
var isRelative = function(url) {
    return(// If a location object is passed, it's always internal, since it's
    // created by `useLocation`.
    isLocation(url) || (url === null || url === void 0 ? void 0 : url.startsWith('javascript:')) || (url === null || url === void 0 ? void 0 : url.startsWith('#')) || (url === null || url === void 0 ? void 0 : url.startsWith('?')) || Boolean(url === null || url === void 0 ? void 0 : url.match(/^\/(?!\/)/)));
};
export var isDownload = function(url) {
    var regex = /\.[0-9a-z]+$/i;
    return url ? isLocation(url) ? Boolean(url.pathname.match(regex)) : Boolean(url.match(regex)) : false;
};
var isLocation = function(input) {
    return typeof input !== 'string';
};
export var Link = /*#__PURE__*/ forwardRef(function Link(_param, ref) {
    var href = _param.href, search = _param.search, hash = _param.hash, target = _param.target, props = _object_without_properties(_param, [
        "href",
        "search",
        "hash",
        "target"
    ]);
    if (isInternalTarget(target) && isRelative(href) && !isDownload(href)) {
        return /*#__PURE__*/ React.createElement(LinkComponent, _object_spread({
            href: overrideUrlParameters(href, search, hash),
            target: target,
            ref: ref
        }, props));
    } else {
        return /*#__PURE__*/ React.createElement("a", _object_spread({
            target: target || '_blank',
            rel: props.rel || (isRelative(href) ? undefined : 'noreferrer'),
            href: overrideUrlParameters(href, search, hash),
            ref: ref
        }, props), props.children);
    }
});
export function useLocation() {
    var _useLocationHook = _sliced_to_array(useLocationHook(), 2), location = _useLocationHook[0], navigate = _useLocationHook[1];
    return [
        location,
        function(url, search, hash) {
            navigate(overrideUrlParameters(url, search, hash));
        }
    ];
}
function base64(content) {
    if (typeof btoa === 'undefined') {
        return Buffer.from(content, 'base64').toString('binary');
    }
    return btoa(content);
}
export function parseCloudinaryUrl(url) {
    var prefix = 'https://res.cloudinary.com/';
    var config = url.substring(prefix.length);
    var pos = config.indexOf('/http') + 1 || config.indexOf('/blob:http') + 1 || config.indexOf('//') + 1;
    var source = config.substring(pos);
    var match = RegExp("(?<cloudname>.*?)\\/image\\/fetch\\/.*?\\/f_auto\\/?(?<transform>.*)").exec(config.substring(0, pos - 1));
    if (!match) {
        return undefined;
    }
    var chain = match.groups.transform.split('/');
    var width;
    var height;
    var transforms = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = chain[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var transform = _step.value;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = transform.split(',')[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var operation = _step1.value;
                    // TODO: dimension prediction does not take chained transforms into account
                    if (operation.startsWith('w_')) {
                        width = parseInt(operation.substring(2));
                    } else if (operation.startsWith('h_')) {
                        height = parseInt(operation.substring(2));
                    } else {
                        transforms.push(operation);
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        cloudName: match.groups.cloudname,
        src: source,
        transform: match.groups.transform,
        width: width,
        height: height
    };
}
function dummyImage(mode, config) {
    var width = config.width;
    var height = config.height;
    var boxHeight = Math.floor(height / 10);
    var debug = '<rect x="0" y="'.concat(height / 2 - boxHeight / 2, '" width="100%" height="').concat(boxHeight, '" fill="rgba(0,0,0,0.5)"></rect><text fill="rgba(255,255,255,0.8)" x="50%" y="50%" style="font-family: sans-serif;font-size: ').concat(Math.floor(boxHeight * 0.8), ";line-height: ").concat(Math.floor(boxHeight * 0.8), ';font-weight:bold;text-anchor: middle; dominant-baseline: central;">').concat(width, " x ").concat(height, "</text>");
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="'.concat(width, '" height="').concat(height, '" viewBox="0 0 ').concat(width, " ").concat(height, '">').concat(mode === 'test' ? debug : '', "</svg>");
    return "data:image/svg+xml;base64,".concat(base64(svg));
}
function processImageSource(source) {
    var src = source.src, width = source.width, height = source.height;
    var info = parseCloudinaryUrl(src);
    if (info && [
        'test',
        'demo'
    ].includes(info.cloudName)) {
        var _source_srcset;
        return _object_spread_props(_object_spread({}, source), {
            src: dummyImage(info.cloudName, {
                width: width,
                height: height
            }),
            srcset: ((_source_srcset = source.srcset) === null || _source_srcset === void 0 ? void 0 : _source_srcset.replace(/https:\/\/res\.cloudinary\.com\/[^\s]+/g, function(url) {
                var i = parseCloudinaryUrl(url);
                if (i && [
                    'test',
                    'demo'
                ].includes(i.cloudName)) {
                    return dummyImage(i.cloudName, {
                        width: i.width || width,
                        height: i.height || width * (height / width)
                    });
                }
                return url;
            })) || ''
        });
    }
    return source;
}
export function Image(_param) {
    var source = _param.source, priority = _param.priority, alt = _param.alt, props = _object_without_properties(_param, [
        "source",
        "priority",
        "alt"
    ]);
    var _processImageSource = processImageSource(JSON.parse(source)), originalSrc = _processImageSource.originalSrc, srcset = _processImageSource.srcset, imageData = _object_without_properties(_processImageSource, [
        "originalSrc",
        "srcset"
    ]);
    return /*#__PURE__*/ React.createElement("img", _object_spread(_object_spread_props(_object_spread({
        decoding: priority ? 'sync' : 'async',
        loading: priority ? 'eager' : 'lazy'
    }, imageData), {
        srcSet: srcset,
        "data-src": originalSrc,
        // Set object fit to "cover", to never
        // distort an image, even if the width
        // and height don't match.
        // This is the case when an image is
        // loaded unprocessed for testing.
        style: _object_spread({
            objectFit: 'cover',
            maxWidth: '100%'
        }, imageData.src.startsWith('data:image/svg+xml') ? {
            backgroundImage: "url(".concat(originalSrc, ")"),
            backgroundPosition: 'center',
            backgroundSize: 'cover'
        } : {}),
        alt: alt
    }), props));
}
export function timestamp(input) {
    return new Date(input);
}
var rehypeAddClasses = function(settings) {
    return function(tree) {
        Object.keys(settings || {}).forEach(function(matcher) {
            var cls = settings[matcher];
            selectAll(matcher, tree).forEach(function(node) {
                if (!node.properties) {
                    node.properties = {
                        class: cls
                    };
                } else {
                    node.properties.class = [
                        node.properties.class,
                        cls
                    ].join();
                }
                node.properties['class'] = cls;
            });
        });
    };
};
export function Html(param) {
    var markup = param.markup, classNames = param.classNames, components = param.components, plugins = param.plugins;
    return unified().use(rehypeParse, {
        fragment: true
    }).use(rehypeAddClasses, classNames || {}).use(rehypeSlug).use(plugins || []).use(rehypeReact, {
        Fragment: React.Fragment,
        createElement: createElement,
        passNode: true,
        components: _object_spread({}, _object_spread({
            a: function(props) {
                var _omit = omit(props, [
                    'node'
                ]), children = _omit.children, href = _omit.href, rest = _object_without_properties(_omit, [
                    "children",
                    "href"
                ]);
                return /*#__PURE__*/ createElement(Link, _object_spread({
                    href: href || '/'
                }, rest), children);
            }
        }, components))
    }).processSync(markup).result;
}
